"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Board = void 0;
const vue_1 = require("vue");
const constants = require("../constants");
const BoardSpace_1 = require("./BoardSpace");
const SpaceType_1 = require("../SpaceType");
const TranslateMixin_1 = require("./TranslateMixin");
class GlobalParamLevel {
    constructor(value, isActive, strValue) {
        this.value = value;
        this.isActive = isActive;
        this.strValue = strValue;
    }
}
exports.Board = vue_1.default.component('board', {
    props: {
        spaces: {
            type: Array,
        },
        venusNextExtension: {
            type: Boolean,
        },
        venusScaleLevel: {
            type: Number,
        },
        altVenusBoard: {
            type: Boolean,
        },
        boardName: {
            type: String,
        },
        oceans_count: {
            type: Number,
        },
        oxygen_level: {
            type: Number,
        },
        temperature: {
            type: Number,
        },
        aresExtension: {
            type: Boolean,
        },
        aresData: {
            type: Object,
        },
        promoCardsOption: {
            type: Boolean,
        },
        automaSoloVariant: {
            type: Boolean,
        },
    },
    components: {
        'board-space': BoardSpace_1.BoardSpace,
    },
    data: function () {
        return {
            'constants': constants,
            'isTileHidden': false,
        };
    },
    mixins: [TranslateMixin_1.TranslateMixin],
    methods: {
        getAllSpacesOnMars: function () {
            const boardSpaces = [...this.spaces];
            boardSpaces.sort((space1, space2) => {
                return parseInt(space1.id) - parseInt(space2.id);
            });
            return boardSpaces.filter((s) => {
                return s.spaceType !== SpaceType_1.SpaceType.COLONY;
            });
        },
        getMaxOceansCount: function () {
            if (this.automaSoloVariant)
                return constants.MAX_OCEAN_TILES_AUTOMA;
            return constants.MAX_OCEAN_TILES;
        },
        getSpaceById: function (spaceId) {
            for (const space of this.spaces) {
                if (space.id === spaceId) {
                    return space;
                }
            }
            throw 'Board space not found by id \'' + spaceId + '\'';
        },
        getValuesForParameter: function (targetParameter) {
            const values = [];
            let startValue;
            let endValue;
            let step;
            let curValue;
            let strValue;
            switch (targetParameter) {
                case 'oxygen':
                    startValue = constants.MIN_OXYGEN_LEVEL;
                    endValue = constants.MAX_OXYGEN_LEVEL;
                    step = 1;
                    curValue = this.oxygen_level;
                    break;
                case 'temperature':
                    startValue = constants.MIN_TEMPERATURE;
                    endValue = constants.MAX_TEMPERATURE;
                    step = 2;
                    curValue = this.temperature;
                    break;
                case 'venus':
                    startValue = constants.MIN_VENUS_SCALE;
                    endValue = constants.MAX_VENUS_SCALE;
                    step = 2;
                    curValue = this.venusScaleLevel;
                    break;
                default:
                    throw 'Wrong parameter to get values from';
            }
            for (let value = endValue; value >= startValue; value -= step) {
                strValue = (targetParameter === 'temperature' && value > 0) ? '+' + value : value.toString();
                values.push(new GlobalParamLevel(value, value === curValue, strValue));
            }
            if (this.automaSoloVariant === true) {
                switch (targetParameter) {
                    case 'oxygen':
                        for (let i = values.length - 2; i > 0; i -= 2) {
                            values[i] = new GlobalParamLevel(values[i].value, false, '■');
                        }
                        break;
                    case 'temperature':
                        values[values.length - 3] = new GlobalParamLevel(values[values.length - 3].value, false, '■');
                        values[values.length - 4] = new GlobalParamLevel(values[values.length - 4].value, false, '■');
                        for (let i = values.length - 7; i > 0; i -= 2) {
                            values[i] = new GlobalParamLevel(values[i].value, false, '■');
                        }
                        break;
                    case 'venus':
                        values[1] = new GlobalParamLevel(values[1].value, false, '■');
                        for (let i = 2; i < values.length; i += 2) {
                            values[i] = new GlobalParamLevel(values[i].value, false, '■');
                        }
                        break;
                }
            }
            return values;
        },
        getScaleCSS: function (paramLevel) {
            let css = 'global-numbers-value val-' + paramLevel.value + ' ';
            if (paramLevel.isActive) {
                css += 'val-is-active';
            }
            return css;
        },
        getGameBoardClassName: function () {
            return this.venusNextExtension ? 'board-cont board-with-venus' : 'board-cont board-without-venus';
        },
        toggleHideTile: function () {
            this.isTileHidden = !this.isTileHidden;
        },
        toggleHideTileLabel: function () {
            return this.isTileHidden ? 'show tiles' : 'hide tiles';
        },
        checkHideTile: function () {
            return this.isTileHidden;
        },
    },
    template: `
    <div :class="getGameBoardClassName()">
        <div class="hide-tile-button-container">
        <div class="hide-tile-button" v-on:click.prevent="toggleHideTile()">{{ toggleHideTileLabel() }}</div>
        </div>
        <div class="board-outer-spaces" id="colony_spaces">
            <board-space :space="getSpaceById('01')" text="Ganymede Colony"></board-space>
            <board-space :space="getSpaceById('02')" text="Phobos Space Haven"></board-space>
            <board-space :space="getSpaceById('69')" text="Stanford Torus" v-if="promoCardsOption"></board-space>
            <board-space :space="getSpaceById('70')" text="Luna Metropolis" v-if="venusNextExtension"></board-space>
            <board-space :space="getSpaceById('71')" text="Dawn City" v-if="venusNextExtension"></board-space>
            <board-space :space="getSpaceById('72')" text="Stratopolis" v-if="venusNextExtension"></board-space>
            <board-space :space="getSpaceById('73')" text="Maxwell Base" v-if="venusNextExtension"></board-space>
        </div>

        <div class="global-numbers">
            <div class="global-numbers-temperature">
                <div :class="getScaleCSS(lvl)" v-for="lvl in getValuesForParameter('temperature')">{{ lvl.strValue }}</div>
            </div>

            <div class="global-numbers-oxygen">
                <div :class="getScaleCSS(lvl)" v-for="lvl in getValuesForParameter('oxygen')">{{ lvl.strValue }}</div>
            </div>

            <div class="global-numbers-venus" v-if="venusNextExtension">
                <div :class="getScaleCSS(lvl)" v-for="lvl in getValuesForParameter('venus')">{{ lvl.strValue }}</div>
            </div>

            <div class="global-numbers-oceans">
              <span v-if="this.oceans_count === getMaxOceansCount()">
                <img width="26" src="/assets/misc/circle-checkmark.png" class="board-ocean-checkmark" :alt="$t('Completed!')">
              </span>
              <span v-else>
                {{this.oceans_count}}/{{this.automaSoloVariant ? this.constants.MAX_OCEAN_TILES_AUTOMA : this.constants.MAX_OCEAN_TILES}}
              </span>
            </div>

            <div v-if="aresExtension && aresData !== undefined">
                <div v-if="aresData.hazardData.erosionOceanCount.available">
                    <div class="global-ares-erosions-icon"></div>
                    <div class="global-ares-erosions-val">{{aresData.hazardData.erosionOceanCount.threshold}}</div>
                </div>
                <div v-if="aresData.hazardData.removeDustStormsOceanCount.available">
                    <div class="global-ares-remove-dust-storms-icon"></div>
                    <div class="global-ares-remove-dust-storms-val">{{aresData.hazardData.removeDustStormsOceanCount.threshold}}</div>
                </div>
                <div v-if="aresData.hazardData.severeErosionTemperature.available">
                    <div class="global-ares-severe-erosions"
                    :class="'global-ares-severe-erosions-'+aresData.hazardData.severeErosionTemperature.threshold"></div>
                </div>
                <div v-if="aresData.hazardData.severeDustStormOxygen.available">
                    <div class="global-ares-severe-dust-storms"
                    :class="'global-ares-severe-dust-storms-'+aresData.hazardData.severeDustStormOxygen.threshold"></div>
                </div>
            </div>

            <div v-if="altVenusBoard" class="global-alt-venus">
              <div class="std-wild-resource p18"></div>
              <div class="std-wild-resource p20"></div>
              <div class="std-wild-resource p22"></div>
              <div class="std-wild-resource p24"></div>
              <div class="std-wild-resource p26"></div>
              <div class="std-wild-resource p28"></div>
              <div class="std-wild-resource p30"></div>
              <div class="wild-resource p30b"></div>
            </div>
        </div>

        <div class="board" id="main_board">
            <board-space :space="curSpace" :key="'board-space-'+curSpace.id" :aresExtension="aresExtension" :isTileHidden="checkHideTile()" v-for="curSpace in getAllSpacesOnMars()"></board-space>
            <svg id="board_legend" height="550" width="630" class="board-legend">
                <g v-if="boardName === 'tharsis'" id="noctis_city" transform="translate(85, 320)">
                    <text class="board-caption">
                        <tspan dy="15">Noctis</tspan>
                        <tspan x="7" dy="12">City</tspan>
                    </text>
                    <line x1="30" y1="20" x2="140" y2="-20" class="board-line"></line>
                    <text x="136" y="-18" class="board-caption board_caption--black">&#x25cf;</text>
                </g>
            </svg>
        </div>
    </div>
    `,
});
//# sourceMappingURL=Board.js.map